import moment from 'moment'
import * as React from 'react'

interface Props {
    date: moment.Moment | string
    format?: string
    displayFormat?: string
}

class MomentDate extends React.PureComponent<Props> {
    public static defaultProps = {
        format: 'YYYY-MM-DD HH:mm:ss Z',
        displayFormat: 'DD.MM. HH:mm',
    }

    public render() {
        const { date, format, displayFormat } = this.props
        const m = moment.utc(date, format).local()

        const title = `${m.fromNow()}, ${m.format('DD.MM.YYYY HH:mm ZZ')}`
        const display = m.isSame(moment(), 'day') ? m.format('HH:mm') : m.format(displayFormat)

        return <span title={title}>{display}</span>
    }
}

export default MomentDate
